<template>
  <ManageWeekendDeliveryDrawer>
    <template #body="{ close }">
      <p class="heading-2 mb-6">
        {{ i18n(translations.setUpShippingConfigurationDrawerHeadline) }}
      </p>
      <p class="mb-24">
        {{ i18n(translations.setUpShippingConfigurationDrawerInstruction) }}
      </p>
      <RevCard class="p-48 text-center">
        <p class="mb-24">
          {{ i18n(translations.setUpShippingConfigurationInstruction) }}
        </p>
        <RevButton size="small" variant="primary" @click="close">
          {{ i18n(translations.setUpShippingConfigurationAction) }}
        </RevButton>
      </RevCard>
    </template>
    <template #trigger="{ open }">
      <RevButton
        :icon="IconChevronRight"
        size="small"
        variant="secondary"
        @click="open"
      >
        {{ i18n(translations.setUpShippingConfigurationTrigger) }}
      </RevButton>
    </template>
  </ManageWeekendDeliveryDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import ManageWeekendDeliveryDrawer from '../ManageWeekendDeliveryDrawer/ManageWeekendDeliveryDrawer.vue'

import translations from './SetUpShippingConfiguration.translations'

const i18n = useI18n()
</script>
